<template>
    <div class="ppv2-flex ppv2-gap-2 ppv2-justify-between ppv2-items-center ppv2-pb-8 ppv2-w-full" v-if="totalPages >= 1">
        <div class="ppv2-flex md:ppv2-px-4 ppv2-items-center md:ppv2-min-w-[33%]" :style="{ gap: normalizeSize(23, true) }">
            <span
                class="poppinsRegular ppv2-text-black ppv2-text-opacity-70 ppv2-hidden sm:ppv2-inline-block"
                :style="{ fontSize: normalizeFontSize(15) }"
                >{{ $t('common.linePerPage') }}</span
            >
            <BaseSelect
                :options="perPageOptionsFormatted"
                v-model="selectedPerPage"
                :searchable="false"
                :clearable="false"
                :is-chevrons-up-down="false"
                class-added="select-per-page"
                :custom-size-label="14"
                @input="onPerPageChange"
                dropdown-placement="top"
            />
        </div>
        <div class="d-flex align-items-center gap-2">
            <button
                class="btn-pagination poppinsMedium ppv2-text-black"
                :class="{ disabled: currentPage === 1 }"
                @click="gotoPage(1)"
            >
                <ChevronsLeft :size="13" />
            </button>
            <button class="btn-pagination" :class="{ disabled: currentPage === 1 }" @click="prevPage">
                <ChevronLeft :size="13" />
            </button>
            <button
                v-for="page in visiblePages"
                :key="page"
                class="btn-pagination poppinsMedium ppv2-text-black"
                :class="{ currentPage: page === currentPage }"
                @click="gotoPage(page)"
                :disabled="page === currentPage"
            >
                {{ page }}
            </button>
            <button
                class="btn-pagination poppinsMedium ppv2-text-black"
                :class="{ disabled: currentPage === totalPages }"
                @click="nextPage"
            >
                <ChevronRight :size="13" />
            </button>
            <button
                class="btn-pagination ppv2-text-black"
                :class="{ disabled: currentPage === totalPages }"
                @click="gotoPage(totalPages)"
            >
                <ChevronsRight :size="13" />
            </button>
        </div>
    </div>
</template>

<script>
import { eventBus } from './eventBus'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import normalizeSize from '../../utils/normalizeSize'
import { ChevronRight, ChevronLeft, ChevronsLeft, ChevronsRight } from 'lucide-vue'
import BaseSelect from '../Shared/BaseSelect.vue'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'Pagination',
    components: {
        vSelect,
        ChevronRight,
        ChevronLeft,
        ChevronsLeft,
        ChevronsRight,
        BaseSelect,
    },
    props: {
        columns: {
            type: Array,
            required: false,
            default: () => [],
        },
        currentPage: {
            type: Number,
            required: true,
        },
        totalPages: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            default: 10,
        },
        applyFilters: {
            type: Array,
            required: false,
        },
        selectedCampagneUuid: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            search: '',
            selectedFilter: '',
            showColumns: false,
            perPageOptions: [10, 25, 50, 100],
            selectedPerPage: this.perPage || 10,
            selectedColumns: this.columns.filter((column) => column.filterable).map((column) => column.label),
            isDownloading: false,
        }
    },
    watch: {
        perPage(newVal) {
            this.selectedPerPage = newVal
        },
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        prevPage() {
            if (this.currentPage > 1) {
                this.$emit('page-changed', this.currentPage - 1)
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.$emit('page-changed', this.currentPage + 1)
            }
        },
        gotoPage(page) {
            this.$emit('page-changed', page)
        },
        onPerPageChange(value) {
            eventBus.$emit('dt-selected-perpage-changed', value)
            this.$emit('per-page-changed', value)
        },

        downloadCustomers() {
            if (this.isDownloading) return
            this.$emit('download-customer')
            this.isDownloading = true
            setTimeout(() => {
                this.isDownloading = false
            }, 5000)
        },
    },
    computed: {
        // Format les options pour BaseSelect
        perPageOptionsFormatted() {
            return this.perPageOptions.map((option) => ({
                label: option.toString(),
                value: option,
            }))
        },
        // Calcule les pages visibles autour de la page courante
        visiblePages() {
            const pages = []
            const totalVisible = 4 // Nombre de boutons de pages à afficher
            let startPage = this.currentPage

            // Ajuster le départ pour toujours afficher 4 pages
            if (this.currentPage > this.totalPages - totalVisible + 1) {
                startPage = Math.max(1, this.totalPages - totalVisible + 1)
            } else {
                startPage = Math.max(1, this.currentPage)
            }

            // Générer les pages à afficher
            for (let i = 0; i < totalVisible && startPage + i <= this.totalPages; i++) {
                pages.push(startPage + i)
            }

            return pages
        },
    },
}
</script>

<style scoped lang="scss">
.pagination {
    float: inline-end;
    text-align: center;
}

.pagination button {
    margin: 0 5px;
    padding: 5px 10px;
    cursor: pointer;
}

.top-bar-datatable {
    display: flex;
}

.block {
    width: 50%;
    padding: 20px;
    box-sizing: border-box;
}

.serach {
    position: relative;
    padding-left: 43px;
    height: 40px;
}

.tooltip {
    position: absolute;
    background-color: #fff;
    color: #0238;
    border: solid 1px #e2e8f0;
    padding: 20px;
    border-radius: 13px;
    z-index: 999;
    max-width: 500px;
    min-width: 200px;
    margin-top: 5px;
    box-shadow: 0px 0px 7px 2px #e2e8f0;
    font-size: 16px;
    max-height: 300px;
    overflow: auto;
}
.btn-pagination:disabled {
    cursor: default;
}
.light .btn-pagination.disabled {
    background-color: #e8e9eb !important;
    border: 1px solid #eeeeee33 !important;
    color: #8e8e8e !important;
    cursor: default !important;
}
.dark .btn-pagination.disabled {
    opacity: 0.5;
    cursor: default !important;
}
.btn-close-tooltip {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: #f8fafc !important;
    margin: 0 !important;
    height: 38px;
    width: 41px;
    margin-bottom: 10px !important;
}

.select-per-page {
    max-width: 85px !important;
    min-width: 75px !important;
}

::v-deep .select-per-page .v-select {
    height: 40px !important;
}

::v-deep .select-per-page .vs__dropdown-toggle {
    min-height: 40px !important;
    height: 40px !important;
}
</style>
